export function parseTitleForYears(title: string, endDate: Date) {
  if (title.includes("{years}")) {
    const startYear = 1987;
    const currentYear = endDate.getFullYear();
    const currentYearFormatted =
      // Start date was 1987-04-01
      new Date(`${currentYear}-04-01`) <= endDate
        ? currentYear
        : currentYear - 1;
    const diff = currentYearFormatted - startYear;

    return title.replace("{years}", String(diff));
  }

  return title;
}
